import { Link } from 'gatsby';
import { Heading } from '@primer/react';
import FormsLayout from '~/src/layouts/forms-layout';
import * as React from 'react';
export default {
  Link,
  Heading,
  FormsLayout,
  React
};